import { useState, useEffect, useCallback } from 'react'

export const useProgressSimulation = (duration = 5000, increment = 1) => {
  const [progress, setProgress] = useState(0)
  const [isRunning, setIsRunning] = useState(false)

  const startProgress = useCallback(() => {
    setIsRunning(true)
    setProgress(0)
  }, [])

  useEffect(() => {
    if (!isRunning) return

    const intervalTime = duration / (100 / increment)
    const interval = setInterval(() => {
      setProgress(prev => {
        const next = prev + increment
        if (next >= 100) {
          setIsRunning(false)
          return 100
        }
        return next
      })
    }, intervalTime)

    return () => clearInterval(interval)
  }, [isRunning, duration, increment])

  return { progress, startProgress }
}
